import { useState, type FormEvent } from "react";
import { analytics, site } from "@/content";

export interface LeadToast {
  message: string;
  type: "success" | "error";
  visible: boolean;
}

/**
 * Логика формы заявки — одна на светлую и тёмную тему.
 * Оформление отличается, поведение идентично.
 */
export function useAnalyticsLeadForm() {
  const form = analytics.form;

  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [managers, setManagers] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [toast, setToast] = useState<LeadToast>({
    message: "",
    type: "success",
    visible: false,
  });

  const showToast = (message: string, type: LeadToast["type"]) =>
    setToast({ message, type, visible: true });

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!agreed) {
      showToast(form.errors.consent, "error");
      return;
    }

    const formEl = event.currentTarget;
    const textarea = formEl.querySelector("textarea");
    if (textarea && textarea.value.length > 500) {
      showToast(form.errors.tooLong, "error");
      return;
    }

    setLoading(true);
    const data = new URLSearchParams(
      new FormData(formEl) as unknown as Record<string, string>
    );
    data.append("managers_count", managers);
    data.append("page_path", window.location.pathname);
    data.append("form_name", "analytics-contact-form");

    try {
      await fetch(site.webhookUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      showToast(form.errors.successToast, "success");
      setSubmitted(true);
      formEl.reset();
      setCharCount(0);
      setManagers("");
      setAgreed(false);
    } catch {
      showToast(form.errors.generic, "error");
    } finally {
      setLoading(false);
    }
  };

  return {
    form,
    loading,
    charCount,
    setCharCount,
    managers,
    setManagers,
    agreed,
    setAgreed,
    submitted,
    setSubmitted,
    toast,
    setToast,
    handleSubmit,
  };
}
